import type { ReactNode } from "react"
import { Header } from "./Header"
import { Footer } from "./Footer"
import { PromoBanner } from "./PromoBanner"
import { useShareCountScript } from "./ShareCount"

export default function MarketingLayout({ children }: { children: ReactNode }) {
  useShareCountScript()
  return (
    <div className="isolate flex min-h-dvh flex-col bg-white text-ink-950">
      <PromoBanner />
      <Header />
      <main className="flex-1">{children}</main>
      <Footer />
    </div>
  )
}
